import axios from "axios";
import { trackClientApiError } from "../utils/analytics";

const api = axios.create({
  baseURL: ""
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    trackClientApiError({
      status: error.response?.status,
      method: error.config?.method,
      path: error.config?.url
    });
    return Promise.reject(error);
  }
);

export default api;
